import { Component, OnInit } from '@angular/core'
import { Product, ProductDepot } from 'depoto-core/src/entities'
import { CoreService } from '../../../services'
import { ProductDetailService } from '../../../services/product-detail.service'
import * as Sentry from '@sentry/angular-ivy'
import { CompanyUtilService } from '../../../services/company-util.service'
import { SchemaUtil, wait } from '../../../utils'

@Component({
  selector: 'product-depots-form',
  templateUrl: './product-depots-form.component.html',
  styles: [
    `
      .quantityStock {
        color: #000;
      }
      .quantityReservation {
        color: #e8261e;
      }
      .quantityAvailable {
        color: #086e11;
      }
    `,
  ],
  styleUrls: ['product-depots-form.component.scss'],
})
export class ProductDepotsFormComponent implements OnInit {
  isShowingNullStock = false
  arePositionsEnabled: boolean

  constructor(
    public productDetailService: ProductDetailService,
    private core: CoreService,
    public companyUtil: CompanyUtilService,
  ) {}

  ngOnInit() {
    this.arePositionsEnabled = this.companyUtil.arePositionsEnabled
  }

  public async modalStockResult(depot?) {
    try {
      const p = await this.core.services.product.getById(this.productDetailService.product.id, {
        id: null,
        productDepots: {
          id: null,
          quantityStock: null,
        },
      })
      const productDepot = this.productDetailService.product.productDepots.find(pD => pD.id === depot.id)
      productDepot.quantityStock = p.productDepots.find(pD => pD.id === depot.id).quantityStock
      productDepot.position = `${productDepot.position1 || ''}-${productDepot.position2 || ''}-${
        productDepot.position3 || ''
      }`
      await wait(200)
      this.productDetailService.product = await this.productDetailService.getProduct(
        this.productDetailService.product.id,
      )
      this.productDetailService.formatStock()
    } catch (err) {
      console.log(err)
    }
  }

  hasPDepotItemsToShow(pDepot): boolean {
    if (pDepot?.items?.length > 0) {
      if (this.isShowingNullStock) return true
      else return pDepot.items.some(item => item.quantityStock > 0)
    } else return false
  }

  hasPDepotPurchaseOrderItemsToShow(pDepot): boolean {
    return pDepot?.purchaseOrderItems?.length > 0
  }

  getQuantityStock() {
    return this.stock.reduce((total, item) => {
      return total + item.sumAll
    }, 0)
  }

  printQR(depot: ProductDepot) {
    window['dataQR'] = {
      batch: depot.batch || '',
      expirationDate: depot.expirationDate || '',
    }
    setTimeout(() => {
      const tabHeadingEl = document.getElementById(`product-tab-qr-link`)
      if (tabHeadingEl) {
        tabHeadingEl.click()
      }
    }, 300)
  }

  get product() {
    return this.productDetailService.product
  }

  get depots() {
    return this.productDetailService.depots
  }

  get suppliers() {
    return this.productDetailService.suppliers
  }

  get currencies() {
    return this.productDetailService.currencies
  }

  get stock() {
    return this.productDetailService.stock
  }

  isQuantityUnderMinimum(stockItem) {
    const totalQuantityOnDepot = stockItem.items.reduce((total, pDepot) => {
      return pDepot.quantityStock + total
    }, 0)
    const metricOfThisDepot = this.productDetailService.product.metrics.find(
      metric => metric.depot.id === stockItem.depot.id,
    )
    return totalQuantityOnDepot < metricOfThisDepot?.quantityMinimum
  }

  isProductDepotExpired(pDepot) {
    const newDate = new Date()
    const todayDate = newDate.getTime()
    if (pDepot.expirationDate?.length > 0) {
      const expDate = new Date(pDepot.expirationDate)
      return expDate.getTime() < todayDate
    } else {
      return false
    }
  }

  getPackPiecesIfInPack(): number {
    let byPieces = 1
    if (this.product?.tags?.some(t => t.externalId === 'hs-count-by-piece')) {
      byPieces = this.product?.packs?.find(t => t.externalId === 'hs-count-by-piece')?.quantity || 1
    }
    return byPieces
  }
}
